<template>
  <ul class="menu-nav">
    <template v-for="(item, i) in listItem">
      <router-link
        v-if="item.route"
        :key="i"
        :to="item.route"
        v-slot="{ href, navigate, isActive, isExactActive }"
        v-show="
          checkPermissions(listPermission, item.actions) || item.isVisible
        "
      >
        <li
          aria-haspopup="true"
          data-menu-toggle="hover"
          class="menu-item"
          :class="[
            isActive && !item.submenu && !isExcluded(item) && 'menu-item-active',
            isExactActive && !item.submenu && 'menu-item-active',
            item.submenu && 'menu-item-submenu',
            getOpenMenu(item.submenu) && 'menu-item-open menu-item-active',
          ]"
          :key="`${i}-${item.id}`"
        >
          <a
            :href="href"
            class="menu-link"
            @click="navigate"
            v-bind:class="{
              'menu-toggle': item.submenu,
            }"
          >
            <i :class="item.icon"></i>
            <span class="menu-text">{{ item.name }}</span>
            <i v-if="item.submenu" class="menu-arrow"></i>
          </a>
          <!-- RENDERING SUBMENU -->
          <div
            v-if="item.submenu"
            class="menu-submenu menu-submenu-classic menu-submenu-right"
          >
            <ul class="menu-subnav">
              <template v-for="(sub, index) in item.submenu">
                <router-link
                  v-if="sub.route"
                  :key="`sub-${index}`"
                  :to="sub.route"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-show="
                    checkPermissions(listPermission, sub.actions) ||
                    sub.isVisible
                  "
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isExactActive && 'menu-item-active']"
                    :key="`sub-li-${index}`"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <i :class="sub.icon"></i>
                      <span class="menu-text">{{ sub.name }}</span>
                    </a>
                  </li>
                </router-link>
              </template>
            </ul>
          </div>
        </li>
      </router-link>
    </template>
  </ul>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { checkPermissions } from '@/utils/permission';

export default {
  name: 'MenuItem',
  props: {
    listItem: Array,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['listPermission']),
  },
  created() {},
  methods: {
    checkPermissions,
    isExcluded(item) {
      if (item.excludeWhenActive && Array.isArray(item.excludeWhenActive)) {
        const path = this.$route.path || '';
        return item.excludeWhenActive.some((p) =>
          path === p || path.startsWith(p + '/'),
        );
      }
      return false;
    },
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1;
    },
    getOpenMenu(submenu) {
      if (submenu) {
        const fullPath = this.$route.fullPath;
        const isMatch = _.find(submenu, (item) => {
          return _.startsWith(fullPath, item.route);
        });
        if (isMatch) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
